//
import gql from 'graphql-tag'
import { getClient } from '@/api/api.js'
import addToFavoriteMutation from './graphql/mutation/addToFavoriteMutation.graphql'
import removeFromFavoriteMutation from './graphql/mutation/removeFromFavoriteMutation.graphql'
import renameFunctionMenuMutation from './graphql/mutation/renameFunctionMenuMutation.graphql'
import changePassword from './graphql/mutation/changePassword.graphql'
import menuSaveSettings from './graphql/mutation/menuSaveSettings.graphql'
import menuSaveTemplatesDescription from './graphql/mutation/saveTemplateDescription.graphql'
import menuDeleteTemplatesDescription from './graphql/mutation/deleteTemplateDescription.graphql'
import doRmdUserAction from './graphql/mutation/doRmdUserAction.graphql'

import fullPathQuery from './graphql/query/fullPathQuery.graphql'
import loadModuleQuery from './graphql/query/loadModuleQuery.graphql'
import menuQuery from './graphql/query/menuQuery.graphql'
import menuListItems from './graphql/query/menuListItems.graphql'
import menuSearchResult from './graphql/query/menuSearchResult.graphql'
import mainMenuUnFixState from './graphql/query/mainMenuUnFixState.graphql'
import mainUsersAngGroupsData from './graphql/query/menuSettingsUsersGroups.graphql'
import menuTemplatesDescription from './graphql/query/menuTemplatesDescription.graphql'
import mainMenuIsHelpShowed from './graphql/query/mainMenuIsHelpShowed.graphql'
import getRestartTicket from './graphql/query/getRestartTicket.graphql'
import getUserActions from './graphql/query/getUserActions.graphql'


export class MainMenuApi {
  static async getMenu() {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${menuQuery}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getModule(codeMenu) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${loadModuleQuery}`,
        variables: { codeMenu: codeMenu }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getFullPath(codeMenu, startParams) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${fullPathQuery}`,
        variables: { codeMenu: codeMenu, startParams: startParams }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getMenuListItems(groupId) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${menuListItems}`,
        variables: { groupId: groupId }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async removeFromFavorite(codeMenu) {
    try {
      const client = await getClient('menuSchema')
      return await client.mutate({
        mutation: gql`${removeFromFavoriteMutation}`,
        variables: {codeMenu: codeMenu}
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async renameFunctionMenu(npp, caption) {
    try {
      const client = await getClient('menuSchema')
      return await client.mutate({
        mutation: gql`${renameFunctionMenuMutation}`,
        variables: { npp: npp, caption: caption }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async addToFavorite(codeMenu) {
    try {
      const client = await getClient('menuSchema')
      return await client.mutate({
        mutation: gql`${addToFavoriteMutation}`,
        variables: { codeMenu: codeMenu }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
  
  static async changePassword({oldPassword, newPassword}) {
    try {
      const client = await getClient('menuSchema')
      return await client.mutate({
        mutation: gql`${changePassword}`,
        variables: { oldPassword: oldPassword, newPassword: newPassword }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getSearchResult(text) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${menuSearchResult}`,
        variables: { text: text }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async mainMenuUnFixState(needSet, state) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${mainMenuUnFixState}`,
        variables: { needSet: needSet, state: state }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async saveMainMenuLayoutSettings(isUserSettings, id, layoutSettings) {
    try {
      const client = await getClient('menuSettingsSchema')
      return await client.mutate({
        mutation: gql`${menuSaveSettings}`,
        variables: { isUser: isUserSettings, id: id, layoutSettings: layoutSettings }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
  
  static async getUsersAndGroupsData() {
    try {
      const client = await getClient('menuSettingsSchema')
      return await client.query({
        query: gql`${mainUsersAngGroupsData}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getMenuTemplatesDescription() {
    try {
      const client = await getClient('menuSettingsSchema')
      return await client.query({
        query: gql`${menuTemplatesDescription}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async menuSaveTemplateDescription(caption, imageB64, jsonString) {
    try {
      const client = await getClient('menuSettingsSchema')
      return await client.mutate({
        mutation: gql`${menuSaveTemplatesDescription}`,
        variables: { caption: caption, imageB64: imageB64, jsonString: jsonString }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async menuDeleteTemplateDescription(id) {
    try {
      const client = await getClient('menuSettingsSchema')
      return await client.mutate({
        mutation: gql`${menuDeleteTemplatesDescription}`,
        variables: { id: id }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async mainMenuIsHelpShowed(needSet, state) {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${mainMenuIsHelpShowed}`,
        variables: { needSet: needSet, state: state }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getRestartTicket() {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${getRestartTicket}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async getUserActions() {
    try {
      const client = await getClient('menuSchema')
      return await client.query({
        query: gql`${getUserActions}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }

  static async doRmdUserAction(actionName, key, dontAsk, rememberChoice) {
    try {
      const client = await getClient('menuSchema')
      return await client.mutate({
        mutation: gql`${doRmdUserAction}`,
        variables: { actionName: actionName, key: key, dontAsk: dontAsk, rememberChoice: rememberChoice }
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
}